import { render, staticRenderFns } from "./LabelColorCustomization.vue?vue&type=template&id=217f83cc&scoped=true"
import script from "./LabelColorCustomization.vue?vue&type=script&lang=js"
export * from "./LabelColorCustomization.vue?vue&type=script&lang=js"
import style0 from "./LabelColorCustomization.vue?vue&type=style&index=0&id=217f83cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f83cc",
  null
  
)

export default component.exports